import axios from "axios";
import { AddressPost, AddressResponse, LoactionResponse } from "app/types/address";
const NET_URL = process.env.REACT_APP_API_NET;

export const getPersonAddress = async (personId: number | string) => {
    const data = await axios.get<AddressResponse>(`${NET_URL}AddressPerson/${personId}/person`);
    return data.data.data;
};

export const postPersonAddress = async (body: AddressPost) => {
    return axios.post(`${NET_URL}AddressPerson`, body);
};

export const getLocationByCp = async (codePostal: string | number) => {
    const data = await axios.get<LoactionResponse>(`${NET_URL}Locality/${codePostal}/code-postal`);
    return data.data.data;
}
